module.exports = __webpack_public_path__ + "img/box3.0a7f690b.png";